module.exports = __webpack_public_path__ + "media/images/banner/covid/zh-hans-8ae0c7b5e5fdd58a7d2375e0d54b709a.jpg";